import {useCallback, useState} from 'react';
import Geolocation, {
  GeolocationResponse,
  GeolocationError,
  GeolocationOptions,
} from '@react-native-community/geolocation';

export type UseLocationReturn = {
  location: GeolocationResponse | null;
  error: GeolocationError | null;
  isLocationPermissionEnabled: boolean;
  refreshLocationPermission: (opts?: GeolocationOptions) => void;
};

const DEFAULT_OPTS: GeolocationOptions = {
  enableHighAccuracy: false,
  timeout: 30000,
  maximumAge: 1000,
};

export function useLocation() {
  const [location, setLocation] = useState<GeolocationResponse | null>(null);
  const [error, setError] = useState<GeolocationError | null>(null);
  const [isLocationPermissionEnabled, setPerm] = useState(false);

  const refreshLocationPermission = useCallback((opts?: GeolocationOptions) => {
    Geolocation.getCurrentPosition(
      (pos) => {
        setLocation(pos);
        setError(null);
        setPerm(true);
      },
      (err) => {
        setLocation(null);
        setError(err);
        if (err?.code === 1) {
          setPerm(false);
        }
      },
      {...DEFAULT_OPTS, ...opts},
    );
  }, []);

  return {
    location,
    error,
    isLocationPermissionEnabled,
    refreshLocationPermission,
  };
}
